import styled from "styled-components";

export const IncomeCalculationWrapper = styled.div`
  width: 300px;
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0px 15px 40px rgba(184, 184, 184, 0.2), 0px 5px 10px rgba(184, 184, 184, 0.05);
  overflow: auto;
  max-height: 100%;
  // padding-bottom: 8px;
`;

export const IncomeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  background-color: #E8D5E8;
  padding: 0 20px;
  box-sizing: border-box;
  font-weight: 600;
  color: #6B2D6B;
`;

export const IncomeRow = styled.div<{ $highlighted?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: 8px 20px;
  font-size: 13px;
  background-color: ${(props) => (props.$highlighted ? "#E8F5E9" : "transparent")};
  border: ${(props) => (props.$highlighted ? "2px solid #4CAF50" : "none")};
  border-bottom: ${(props) => (props.$highlighted ? "2px solid #4CAF50" : "1px solid #E2E2E1")};
  border-radius: ${(props) => (props.$highlighted ? "4px" : "0")};
  margin: ${(props) => (props.$highlighted ? "8px 10px" : "0")};

  &:last-child {
    border-bottom: ${(props) => (props.$highlighted ? "2px solid #4CAF50" : "none")};
  }
`;

export const IncomeValue = styled.span`
  color: #4CAF50;
  font-weight: 500;
`;
